var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-avatar',{staticStyle:{"vertical-align":"middle"},attrs:{"shape":_vm.shape,"size":_vm.size,"src":_vm.src},on:{"error":() => true}},[_c('div',{style:(_vm.avatarTextStyle)},[_vm._v(_vm._s(_vm.showName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }